import { activityTypes } from '@rockalingua/shared/activities/constants';

const ActivityTypes = {
  ...activityTypes,
  asArray: [
    'song',
    'video',
    'craft',
    'pictureDictionary',
    'interactiveVideo',
    'game',
    'worksheet',
    // 'shortStory',
    'realTime',
    'comic',
    'storyWithQuestions',
    'songQuestions',
  ],
  withLabels: [
    { value: 'video', label: 'Videos', labelSingular: 'Video' },
    { value: 'game', label: 'Games', labelSingular: 'Game' },
    { value: 'song', label: 'Songs', labelSingular: 'Song' },
    { value: 'worksheet', label: 'Worksheets', labelSingular: 'Worksheet' },
    {
      value: 'pictureDictionary',
      label: 'Picture Dictionaries',
      labelSingular: 'Picture Dictionary',
    },
    // {
    //   value: 'shortStory',
    //   label: 'Short Stories',
    //   labelSingular: 'Short Story',
    // },
    { value: 'craft', label: 'Crafts', labelSingular: 'Craft' },
    {
      value: 'interactiveVideo',
      label: 'Videos with Questions',
      labelSingular: 'Video with Questions',
    },
    { value: 'realTime', label: 'Live tasks', labelSingular: 'Live task' },
    { value: 'comic', label: 'Comics', labelSingular: 'Comic' },
    {
      value: 'storyWithQuestions',
      label: 'Stories with questions',
      labelSingular: 'Story with questions',
    },
    {
      value: 'songQuestions',
      label: 'Song challenges',
      labelSingular: 'Song challenge',
    },
  ],
  toSlug: {
    craft: 'crafts',
    game: 'games',
    pictureDictionary: 'picture-dictionaries',
    shortStory: 'short-stories',
    song: 'songs',
    video: 'videos',
    interactiveVideo: 'interactive-videos',
    worksheet: 'worksheets',
    realTime: 'real-time',
    comic: 'comics',
    story: 'stories',
    storyWithQuestions: 'stories-with-questions',
    songQuestions: 'song-questions',
  },
  typesOrdered: [
    'video',
    'interactiveVideo',
    'song',
    'songQuestions',
    'game',
    'shortStory',
    'storyWithQuestions',
    'worksheet',
    'pictureDictionary',
    'craft',
    'realTime',
    'comic',
  ],
};

export default ActivityTypes;
